import { WorkIndividualWorkOperationalReportWidgetStore } from './work-individual-work-operational-report-widget.store';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CheckInputComponent } from '../../../../kit/input/check-input/check-input.component';
import { Validators } from '@angular/forms';
import {
    ServicePatternWysiwygComponent,
} from '../../../../../modules/content/components/common/service-pattern-wysiwyg/service-pattern-wysiwyg.component';
import { ServicePatternStructureUsageEnum } from '@libs/types/src/services/enum/service-pattern-structure-usage.enum';
import { changeSignal, disableFormControls, formAddText } from '../../../../../utils/form.utils';
import { SelectInputComponent } from '../../../../kit/input/select-input/select-input.component';
import {
    serviceOperationalReportPriorityEnumOptions,
} from '@libs/types/src/services/enum/service-operational-report-priority.enum';
import {
    serviceOperationalReportTypeEnumOptions,
} from '@libs/types/src/services/enum/service-operational-report-type.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { stripHtml } from '../../../../../utils/string.utils';
import {
    InputUserMultiselectComponent,
} from '../../../../../modules/shared/components/inputs/input-user-multiselect/input-user-multiselect.component';
import { CardComponent } from '../../../../kit/card/card.component';

@Component({
    selector: 'app-work-individual-work-operational-report-widget',
    templateUrl: './work-individual-work-operational-report-widget.component.html',
    styleUrl: './work-individual-work-operational-report-widget.component.scss',
    standalone: true,
    providers: [WorkIndividualWorkOperationalReportWidgetStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CheckInputComponent,
        ServicePatternWysiwygComponent,
        SelectInputComponent,
        TranslatePipe,
        InputUserMultiselectComponent,
        CardComponent,
    ],
})
export class WorkIndividualWorkOperationalReportWidgetComponent {

    public readonly store = inject(WorkIndividualWorkOperationalReportWidgetStore);

    public serviceId = input.required<number, any>({ transform: v => Number(v || 0) });
    public structureDisabled = input(false);
    public disabled = input(false);

    public form = fb.group({
        sendEmail: fb.control<boolean>(false),
        type: fb.control<string | null>(null, Validators.required),
        priority: fb.control<string | null>(null, Validators.required),
        description: fb.control<string>('', { nonNullable: true }),
        userIds: fb.control<string[]>([]),
    });

    protected descriptionChange = changeSignal(this.form.controls.description);

    constructor() {
        effect(() => {
            if (this.disabled()) {
                disableFormControls(this.form, true);
                return;
            }

            disableFormControls(this.form, this.structureDisabled(), ['description']);
            this.form.controls.description.enable({ emitEvent: false });
        });

        effect(() => {
            if (stripHtml(this.descriptionChange()).trim().length) {
                this.form.controls.priority.setValidators(Validators.required);
                this.form.controls.type.setValidators(Validators.required);
            } else {
                this.form.controls.priority.clearValidators();
                this.form.controls.type.clearValidators();
            }

            this.form.controls.priority.updateValueAndValidity();
            this.form.controls.type.updateValueAndValidity();
        });
    }

    protected readonly ServicePatternStructureUsageEnum = ServicePatternStructureUsageEnum;
    protected readonly formAddText = formAddText;
    protected readonly serviceOperationalReportPriorityEnumOptions = serviceOperationalReportPriorityEnumOptions;
    protected readonly serviceOperationalReportTypeEnumOptions = serviceOperationalReportTypeEnumOptions;
}
